(function (angular) {
  "use strict";

  angular.module('myApp').component('catalogue', {
    templateUrl: '/catalogues/catalogue.tpl.html',
    controller: [
      '$scope', '$http', 
      function ($scope, $http,) {

        $scope.paging = {};
        $scope.filters = {};
        $scope.filters.page = 1;
        $scope.filters.size = 10;

        $scope.load = function () {
          $http.get('api/catalogues',
            { params: $scope.filters }).then(function (resp) {

              $scope.paging = resp.data.paging;
              $scope.list = resp.data.data;
              $("html, body").animate({ scrollTop: 0 }, "slow");
            });
        };

        $scope.load();

        $scope.goToPage = function (page) {
          $scope.filters.page = page;
          $scope.load();
        };
      }
    ],
  });

}(window.angular));
